import request from '@/utils/request'


// 查询刀具费用列表
export function listCuttingTool(query) {
  return request({
    url: '/user/cutting-tool/list',
    method: 'get',
    params: query
  })
}

// 查询刀具费用分页
export function pageCuttingTool(query) {
  return request({
    url: '/user/cutting-tool/page',
    method: 'get',
    params: query
  })
}

// 查询刀具费用详细
export function getCuttingTool(data) {
  return request({
    url: '/user/cutting-tool/detail',
    method: 'get',
    params: data
  })
}

// 新增刀具费用
export function addCuttingTool(data) {
  return request({
    url: '/user/cutting-tool/add',
    method: 'post',
    data: data
  })
}

// 修改刀具费用
export function updateCuttingTool(data) {
  return request({
    url: '/user/cutting-tool/edit',
    method: 'post',
    data: data
  })
}

// 删除刀具费用
export function delCuttingTool(data) {
  return request({
    url: '/user/cutting-tool/delete',
    method: 'post',
    data: data
  })
}

// 更新刀具费用排序（仅更新 sort）
export function updateCuttingToolSort(data) {
  return request({
    url: '/user/cutting-tool/update-sort',
    method: 'post',
    data: data
  })
}

// 更新刀具费用状态（仅更新 status）
export function updateCuttingToolStatus(data) {
  return request({
    url: '/user/cutting-tool/update-status',
    method: 'post',
    data: data
  })
}
